import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Grid, IconButton, TextField, InputAdornment } from '@material-ui/core';

import {getCloseRepairs, GetRepairsFilters} from '../../actions/repairAction'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faSort, faSortAlphaDown, faSortAlphaUpAlt, faSortNumericDown, faSortNumericUpAlt, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { currentScrollingPage } from '../../constants';
import moment from 'moment';
import RepairsFilters from './RepairsFilters';


const initFilters={
    statusSelected:[],
    dateChanged:false,
    dateOptionSelected: null,
    startDate: new Date(),
    endDate: new Date(),
    itemsSelected: [],
    issuesSelected: [],
    responseTime: false,
    responseOption: 'Greater than',
    lowerLimit: 1,
    upperLimit: 10,
    responseUnit:'hours'
}

class RepairsClosed extends Component {
    constructor(props){
        super(props);

        this.state = {
            currentPageClosed: currentScrollingPage,
            
            filtersClosedAnchorEl:null,
            filtersClosedObj: { ...initFilters, statusSelected:[],itemsSelected: [], issuesSelected: [] },
            filtersClosedApply:false,
            openSearchClosed: false,
            searchClosedValue: '',
            sortClosedColumn: 'createdDate',
            sortClosedDesc: false,
        }

        this.observer = React.createRef();
        
        this.lastCloseRef = node => {
            /* FUNCION CALL BACK */
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver(async (entries) => {

                const openNodes = document.querySelectorAll('[id^="repair_closed_"]')
                let nextToEndNode = (openNodes && openNodes.length > 0)?openNodes[openNodes.length-1]: undefined
                const nodeList = document.querySelectorAll('[data-lastelementclose $="Last_Element_Close"]');
                let node = (nodeList && nodeList.length> 0)? nodeList[0]: undefined;

                if (entries[0].isIntersecting) {
                    if(nextToEndNode){
                        nextToEndNode.scrollIntoView(false);
                    }

                    if(node){
                        node= undefined;
                    }
                    const newCurrentPage = this.state.currentPageClosed? this.state.currentPageClosed +1: 1;
                    const res = await this.getCloseScrollingRepair(newCurrentPage)
                    this.setState((prevState) => ({ currentPageClosed: newCurrentPage , stillClose: res}),);

                    // this.setState((prevState) => ({ currentPageClosed: prevState.currentPageClosed + 1 }));
                    // this.getCloseScrollingRepair();
                    setTimeout(() => this.forceUpdate(), 1000);
                }
            });
            if (node) this.observer.current.observe(node)
        };

    };

    componentDidMount(){
        const id = localStorage.getItem('communityId');

        this.props.getCloseRepairs(id, this.state.currentPageClosed)
        
    }

    componentDidUpdate(prevProps){
        if(prevProps.communityId!==this.props.communityId){
            this.setState({
                currentScrollingPage:0,
                filtersClosedAnchorEl:null,
                filtersClosedObj: { ...initFilters, statusSelected:[],itemsSelected: [], issuesSelected: [] },
                filtersClosedApply:false,
                openSearchClosed: false,
                searchClosedValue: '',
                sortClosedColumn: 'createdDate',
                sortClosedDesc: false,
            })
        }
    }

    getCloseScrollingRepair = async (page) => {

        let resCloseRequest = undefined;
        if(this.state.filtersClosedApply){
            resCloseRequest = await this.GetRepairsWithFilters();
        }else{
            resCloseRequest = await this.props.getCloseRepairs(localStorage.getItem('communityId'), page);
        }

        return (resCloseRequest && resCloseRequest.ok)? true: false
    }

    async GetRepairsWithFilters(){

        const id = localStorage.getItem('communityId');

        const res = await this.props.GetRepairsFilters(id, 2, this.state.filtersClosedObj, this.state.currentPageClosed, this.state.searchClosedValue, this.state.sortClosedColumn, this.state.sortClosedDesc );
        return res
    }


    handleSearch = () => {

        this.setState({ filtersClosedApply: true, currentPageClosed: 0 }, () => this.GetRepairsWithFilters());

    }

    handleResetSearch = () => {

        this.setState({ searchClosedValue:'', openSearchClosed: false, currentPageClosed: 0 }, () => this.GetRepairsWithFilters());
        
    }
    handleSort = (column) => {

        const currentColumn = this.state.sortClosedColumn;
           
        const updState = {
            sortClosedColumn: currentColumn,
            sortClosedDesc: this.state.sortClosedDesc,
            currentPageClosed: 0,
            filtersClosedApply: true
        }
    
        if(currentColumn!==column){
            updState.sortClosedColumn = column
            updState.sortClosedDesc = true;
        }else{
            updState.sortClosedDesc = !this.state.sortClosedDesc
        }
    
        this.setState(updState, 
            ()=>this.GetRepairsWithFilters()
        )
        
    }

    applyFilters = (filters) => {

        this.setState({ filtersClosedObj: filters, currentPageClosed: 0, filtersClosedApply: true }, ()=>this.GetRepairsWithFilters());
        
    }

    resetFilters = () => {

        if(this.state.sortClosedColumn ==='createdDate' && this.state.sortClosedDesc === false){ //No sort applied
            this.setState({ 
                filtersClosedObj: {...initFilters, itemsSelected:[], statusSelected:[], issuesSelected:[]}, 
                currentPageClosed: 0,
                filtersClosedApply: false,
                searchClosedValue:'',
                openSearchClosed:false
            }, ()=>this.getCloseScrollingRepair() );
        }else{
            this.setState({ 
                filtersClosedObj: {...initFilters, itemsSelected:[], statusSelected:[], issuesSelected:[]}, 
                currentPageClosed: 0, 
                filtersClosedApply: true, 
                openSearchClosed:false, 
                searchClosedValue:'' 
            },()=>this.GetRepairsWithFilters());
        }
    }

    GetResponseTime = (createddate, repairDate) => {
        const cDate = new Date(createddate);
        const rDate = new Date(repairDate);

        let seconds = Math.floor(Math.abs(cDate - rDate) / 1000);
        let days = 0;
        let hours = 0;
        let minutes = 0;

        let repairTimeString = '';

        if (seconds >= 86400) {
            days = Math.floor(seconds / 86400);
            seconds = seconds - (86400 * days);
            repairTimeString = days + ' d ';
        }

        if (seconds >= 3600) {
            hours = Math.floor(seconds / 3600);
            seconds = seconds - (hours * 3600);
            repairTimeString += hours + ' hr ';
        }

        if (seconds >= 60) {
            minutes = Math.floor(seconds / 60);
            seconds = seconds - (minutes * 60);

            repairTimeString += minutes + ' min ';
        }

        if (repairTimeString === '') {
            repairTimeString = '< 1 min';
        }

        return repairTimeString;
    };


    RenderitemComponnet = ({ item }) => {
        let itemName = (item && item.item && item.item.name) ? item.item.name : '';
        const itemIconUrl = (item && item.item && item.item.iconUrl)? item.item.iconUrl : ''

        if (itemName) {
            itemName = itemName.charAt(0).toUpperCase() + itemName.slice(1);
        }

        return (
            <Grid item container xs={12}  alignItems='center' id='repairsPage_Item'>
                <Grid item className="center" id='repairsPage_Item_Image'>
                    <img alt={'icon Item ' + itemName} src={itemIconUrl} className="LitemIcon logo-black"/>
                </Grid>
                <Grid item className="center medium-size-1" style={{paddingLeft:'5px'}} id='repairsPage_Item_Name'>
                    {itemName}
                </Grid>
            </Grid>
        )
    };

    RenderStatusResponseComponent = ({ item, status }) => {
        const createdDate = item.createdDate ? item.createdDate : undefined;
        const scheduleDate = item.timeLine ? item.timeLine.find(item => item.title === 'Scheduled Date') : undefined;
        const today = new Date();
        const responseTime = (item.orderStatus === 'completed' && item.createdDate && item.repairDate) ? this.GetResponseTime(item.createdDate, item.repairDate) : 'N/A';

        let beforeYesterday = true;

        if (today && createdDate) {
            beforeYesterday = moment(today).subtract(1, 'day') >= moment(createdDate);
        }


        return (
            <Grid item container xs={12} id='repairsPage_Status'>
                {
                    item.orderStatus === 'pending' || item.orderStatus==='scheduled' ?
                        <Grid item container direction='column'  alignItems='center'>
                            <Grid item style={scheduleDate ? { color: '#048ec5' } : beforeYesterday ? { color: '#ac4c5c' } : { color: 'white' }} className="large-1">
                                {!scheduleDate ? 'Opened' : 'Scheduled for'}
                            </Grid>
                            <Grid item className="medium-size-1">
                                {
                                    scheduleDate ?
                                        moment(scheduleDate.timeLineDate).format('M/D hh:mm A')
                                        :
                                        // createdDate ?
                                        //     moment(new Date(createdDate)).format('M/D hh:mm A')
                                        //     :
                                            ' '
                                }
                                { }
                            </Grid>
                        </Grid>
                        :
                        item.orderStatus === 'canceled' ?
                            <Grid item container justifyContent='center' alignItems='center' direction='column'>
                                <Grid item className="large-1 center">{'N/A'}</Grid>
                                <Grid item className="large-1 center">{'Repair Canceled'}</Grid>
                            </Grid>
                            :
                            responseTime ?
                                <Grid item container alignItems='center'>
                                    <Grid item className="medium-size-1 center">{responseTime}</Grid>
                                </Grid>
                                :
                                <Grid className="medium-size-1 center">{'N/A'}</Grid>
                }
            </Grid>
        )
    };

    ResidentSubmitedDateComponent = ({DateSubmitted}) =>{
        try{
            const date = new moment(DateSubmitted);
            let dateFormated = undefined;

            if(date && date._isValid){
                dateFormated= date.format('MM/DD/yyyy');
            }

            return(
                <Grid item container alignContent="center" style={{fontSize:'16px'}}>
                    <Grid item>
                        {dateFormated}
                    </Grid>
                </Grid>
            );
        }catch(err){
            return(
                <Grid item container></Grid>
            );
        }
    }

    render() {
        const currentDataClose = this.props.closedRepairs ? this.props.closedRepairs : [];

        return (
            <>
                <Grid item container xs={12} style={{padding:'20px'}}>
                    {/* Filters and search */}
                    <Grid item container xs={12} justifyContent='flex-end' alignItems='center' style={{padding:'5px 10px'}}>
                        {
                            this.state.openSearchClosed ?
                                <Grid item container xs={10} sm={10} md={6} lg={4}>
                                    <TextField
                                        id='closed_repairs_search'
                                        name='Search'
                                        item
                                        placeholder="Enter search term(s) and press Enter"
                                        value={this.state.searchClosedValue}
                                        fullWidth
                                        // variant='outlined'
                                        InputProps={{
                                            disableUnderline: true,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                     <svg fill='#105A88' width='32px' height='32px' viewBox="0 0 576 512">                                   
                                                        <path xmlns="http://www.w3.org/2000/svg" d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"/>
                                                    </svg>
                                                </InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton id='repairs_closed_clear_btn' onClick={() => this.handleResetSearch()}>
                                                        <FontAwesomeIcon icon={faTimesCircle} color='#105a88' size='sm' />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        inputProps={{
                                            className:'txt_black'
                                        }}
                                        className="repairs_search animate__animated animate__slideInRight"
                                        onChange={(e) => this.setState({ searchClosedValue: e.target.value })}
                                        onKeyDown={(e) => { if (e && e.keyCode === 13) this.handleSearch() }}
                                    />

                                </Grid>
                                :
                                <IconButton item onClick={() => this.setState({ openSearchClosed: true })} id='search_closed_btn'>
                                    <svg fill='#105A88' width='35px' height='35px' viewBox="0 0 576 512">                                   
                                        <path xmlns="http://www.w3.org/2000/svg" d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"/>
                                    </svg>
                                   
                                 </IconButton>
                        }
                        <IconButton 
                            item 
                            onClick={(e) => this.setState({ filtersClosedAnchorEl: e.currentTarget })} 
                            id='filters_btn' 
                        >
                            
                            <svg fill='#105A88' width='35px' height='35px' viewBox="0 0 576 512">                                   
                                <path xmlns="http://www.w3.org/2000/svg" d="M479.968 0H32.038C3.613 0-10.729 34.487 9.41 54.627L192 237.255V424a31.996 31.996 0 0 0 10.928 24.082l64 55.983c20.438 17.883 53.072 3.68 53.072-24.082V237.255L502.595 54.627C522.695 34.528 508.45 0 479.968 0zM288 224v256l-64-56V224L32 32h448L288 224z"/>
                            </svg>
                            
                        </IconButton>

                    </Grid>

                    {/* Column headers */}
                    <Grid item container xs={12} justifyContent='center' alignItems='center' className='LRepairsOpenedHeaders'
                        style={{padding:'10px'}}
                    >
                        <Grid item xs={2}>
                            Resident
                            <IconButton onClick={()=>this.handleSort('resident.lastName')}>
                                <FontAwesomeIcon icon={
                                    (this.state.sortClosedColumn==='resident.lastName' && this.state.sortClosedDesc)? 
                                    faSortAlphaDown 
                                    : 
                                    (this.state.sortClosedColumn==='resident.lastName' && !this.state.sortClosedDesc)? 
                                    faSortAlphaUpAlt 
                                    : 
                                    (this.state.sortClosedColumn!=='resident.lastName')? 
                                    faSort 
                                    :
                                    null
                                    } 
                                    color='#a2a1a2' 
                                />
                            </IconButton>
                        </Grid>
                        <Grid item xs={2}>
                            Location
                            <IconButton onClick={()=>this.handleSort('resident.zoneName')}>
                                <FontAwesomeIcon icon={
                                    (this.state.sortClosedColumn==='resident.zoneName' && this.state.sortClosedDesc)? 
                                    faSortAlphaDown 
                                    : 
                                    (this.state.sortClosedColumn==='resident.zoneName' && !this.state.sortClosedDesc)? 
                                    faSortAlphaUpAlt 
                                    : 
                                    (this.state.sortClosedColumn!=='resident.zoneName')? 
                                    faSort 
                                    :
                                    null
                                    } 
                                    color='#a2a1a2' 
                                />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1}>
                            Room
                            <IconButton onClick={()=>this.handleSort('room.name')}>
                                <FontAwesomeIcon icon={
                                    (this.state.sortClosedColumn==='room.name' && this.state.sortClosedDesc)? 
                                    faSortAlphaDown 
                                    : 
                                    (this.state.sortClosedColumn==='room.name' && !this.state.sortClosedDesc)? 
                                    faSortAlphaUpAlt 
                                    : 
                                    (this.state.sortClosedColumn!=='room.name')? 
                                    faSort 
                                    :
                                    null
                                    } 
                                    color='#a2a1a2' 
                                />
                            </IconButton>
                        </Grid>
                        <Grid item xs={2}>
                            Item
                            <IconButton onClick={()=>this.handleSort('item.name')}>
                                <FontAwesomeIcon icon={
                                    (this.state.sortClosedColumn==='item.name' && this.state.sortClosedDesc)? 
                                    faSortAlphaDown 
                                    : 
                                    (this.state.sortClosedColumn==='item.name' && !this.state.sortClosedDesc)? 
                                    faSortAlphaUpAlt 
                                    : 
                                    (this.state.sortClosedColumn!=='item.name')? 
                                    faSort 
                                    :
                                    null
                                    } 
                                    color='#a2a1a2' 
                                />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1}>
                            Issue
                            <IconButton onClick={()=>this.handleSort('issue.name')}>
                                <FontAwesomeIcon icon={
                                    (this.state.sortClosedColumn==='issue.name' && this.state.sortClosedDesc)? 
                                    faSortAlphaDown 
                                    : 
                                    (this.state.sortClosedColumn==='issue.name' && !this.state.sortClosedDesc)? 
                                    faSortAlphaUpAlt 
                                    : 
                                    (this.state.sortClosedColumn!=='issue.name')? 
                                    faSort 
                                    :
                                    null
                                    } 
                                    color='#a2a1a2' 
                                />
                            </IconButton>
                        </Grid>
                        <Grid item xs={2}>
                            Response Time
                            <IconButton onClick={()=>this.handleSort('responseTime')}>

                                <FontAwesomeIcon icon={
                                    (this.state.sortClosedColumn==='responseTime' && this.state.sortClosedDesc)? 
                                    faSortNumericDown 
                                    : 
                                    (this.state.sortClosedColumn==='responseTime' && !this.state.sortClosedDesc)? 
                                    faSortNumericUpAlt 
                                    : 
                                    (this.state.sortClosedColumn!=='responseTime')? 
                                    faSort 
                                    :
                                    null
                                    } 
                                    color='#a2a1a2' 
                                />
                            </IconButton>
                        </Grid>
                        <Grid item xs={2}>
                            Date Submitted
                            <IconButton onClick={()=>this.handleSort('createdDate')}>

                                <FontAwesomeIcon icon={
                                    (this.state.sortClosedColumn==='createdDate' && this.state.sortClosedDesc)? 
                                    faSortNumericDown 
                                    : 
                                    (this.state.sortClosedColumn==='createdDate' && !this.state.sortClosedDesc)? 
                                    faSortNumericUpAlt 
                                    : 
                                    (this.state.sortClosedColumn!=='createdDate')? 
                                    faSort 
                                    :
                                    null
                                    } 
                                    color='#a2a1a2' 
                                />
                            </IconButton>
                        </Grid>
                    </Grid>

                    {/* Repairs list */}

                    {
                        currentDataClose && currentDataClose.map((repair, index) => {
                            const residentName = (repair.resident && repair.resident.name) ? repair.resident.name : 'N/A';
                            const residentLastName = (repair.resident && repair.resident.lastName) ? repair.resident.lastName : '';

                            return (
                                <Grid container className="LRepairsRow" 
                                    key={`repair_closed_${repair._id}`}
                                    id={`repair_closed_${repair._id}`}
                                    ref={currentDataClose.length === index + 1?this.lastCloseRef:undefined}
                                    onClick={() => {
                                        this.setState({ openRepairDetails: true, repairSelectedForDetails: repair, repairSelectedForDetailsStatus: repair.status, repairsSelected: [repair] }) 
                                        if(this.props.onRepairSelectedForDetails){
                                            this.props.onRepairSelectedForDetails(true, repair, repair.status)
                                        }
                                    }}
                                    style={{
                                        overflow:'hidden', 
                                        textOverflow:'ellipsis',
                                        backgroundColor: index%2===0?'#FAFAFA':'white',
                                        cursor:'pointer',
                                        padding:'10px 10px'
                                    }}

                                >
                                {
                                    (currentDataClose && currentDataClose.length === index+1) && this.state.stillClose?
                                        <Grid item container xs={12} data-lastelementclose={(currentDataClose && currentDataClose.length === index +1)? 'Last_Element_Close':undefined} ref={currentDataClose.length === index + 1?this.lastCloseRef:undefined}/>
                                        :
                                        undefined
                                }
                                <Grid item container xs={12} md={2} className="txt_bold large">
                                    {residentLastName? `${residentLastName}, ${residentName}`:residentName }
                                </Grid>
                                <Grid item container xs={12} md={2} className="txt_black size16">
                                    {repair.resident.zoneName}
                                </Grid>
                                <Grid item container className="txt_black size16" xs={12} md={1}>
                                    {repair.room.name}
                                </Grid>
                                <Grid item container className="size16 txt_black" xs={12} md={2}>
                                    <this.RenderitemComponnet item={repair} />
                                </Grid>
                                <Grid item container className="txt_black size16" xs={12} md={1} id='repairsPage_Item_Issue'>
                                    {repair.issue ? repair.issue.name : ' '}
                                </Grid>
                                <Grid item container className="txt_black size16" xs={12} md={2}>
                                    <this.RenderStatusResponseComponent item={repair} status={repair.status} />
                                </Grid>
                                <Grid item container className="txt_black size16" xs={12} md={2}>
                                    <this.ResidentSubmitedDateComponent DateSubmitted={(repair && repair.createdDate)? repair.createdDate: undefined} />
                                </Grid>
                            </Grid>
                                                        
                        )
                    })
                }                    

                </Grid>

                {
                    this.state.filtersClosedAnchorEl &&
                    <RepairsFilters
                        anchorEl={this.state.filtersClosedAnchorEl}
                        onClose={() => this.setState({ filtersClosedAnchorEl: null })}
                        filters={this.state.filtersClosedObj}
                        tab={2}
                        applyFilters={this.applyFilters}
                        resetFilters={this.resetFilters}
                    />
                }
                
            </>
        )
    }
}

function mapStateToProps(state,dispatch) {
    let currentDataClose = (state.repairReducer?.dashboardRepairData?.closeS)?state.repairReducer?.dashboardRepairData?.closeS : []

    return{
        closedRepairs:currentDataClose
    }
};

export default connect(mapStateToProps,{GetRepairsFilters, getCloseRepairs})(RepairsClosed)
